import { render } from "./PopUpImage.vue?vue&type=template&id=325b3ddf"
import script from "./PopUpImage.vue?vue&type=script&lang=js"
export * from "./PopUpImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__